import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ff2e5b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "box_code"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-4ff2e5b2>扫码完成注册</div><div class=\"steps\" data-v-4ff2e5b2><div class=\"step\" data-v-4ff2e5b2><span class=\"step-num\" data-v-4ff2e5b2>1.</span><span class=\"step-text\" data-v-4ff2e5b2>打开微信，使用&quot;扫一扫&quot;功能</span></div><div class=\"step\" data-v-4ff2e5b2><span class=\"step-num\" data-v-4ff2e5b2>2.</span><span class=\"step-text\" data-v-4ff2e5b2>扫描上方二维码</span></div><div class=\"step\" data-v-4ff2e5b2><span class=\"step-num\" data-v-4ff2e5b2>3.</span><span class=\"step-text\" data-v-4ff2e5b2>在微信中完成注册</span></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_button = _resolveComponent("a-button")!

  return (!$data.expand.code)
    ? (_openBlock(), _createBlock(_component_a_result, {
        key: 0,
        class: "box_result",
        status: "info",
        title: "正在登录",
        "sub-title": "微信信息校验中..."
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: $data.expand.code,
          alt: ""
        }, null, 8 /* PROPS */, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: $options.goBack,
            class: "back-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode("返回")
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ])
      ]))
}